"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CHIEF_COMPLAINT_MAX_LENGTH () {
        return CHIEF_COMPLAINT_MAX_LENGTH;
    },
    get DIAGNOSES_MAX_ITEMS () {
        return DIAGNOSES_MAX_ITEMS;
    },
    get SOAP_TEXT_MAX_LENGTH () {
        return SOAP_TEXT_MAX_LENGTH;
    },
    get SoapUpdateRequestSchema () {
        return SoapUpdateRequestSchema;
    },
    get SoapUpdateResponseSchema () {
        return SoapUpdateResponseSchema;
    }
});
const _zod = require("zod");
const _icd10search = require("../icd10/icd10-search");
const CHIEF_COMPLAINT_MAX_LENGTH = 200;
const SOAP_TEXT_MAX_LENGTH = 10_000;
const DIAGNOSES_MAX_ITEMS = 12;
const blankToNull = (value)=>{
    if (value === undefined) {
        return undefined;
    }
    if (value === null || value.trim() === '') {
        return null;
    }
    return value;
};
const chiefComplaint = _zod.z.string({
    message: 'Chief complaint must be text.'
}).trim().max(CHIEF_COMPLAINT_MAX_LENGTH, {
    message: `Chief complaint must be at most ${CHIEF_COMPLAINT_MAX_LENGTH} characters.`
}).refine((value)=>!/[\r\n]/.test(value), {
    message: 'Chief complaint must be a single line.'
}).nullable().optional().transform(blankToNull);
/**
 * Long-form note text is kept exactly as typed (indentation and blank lines
 * are meaningful in a note); only an all-blank value is normalized to null.
 */ const noteText = (label)=>_zod.z.string({
        message: `${label} must be text.`
    }).max(SOAP_TEXT_MAX_LENGTH, {
        message: `${label} must be at most ${SOAP_TEXT_MAX_LENGTH} characters.`
    }).nullable().optional().transform(blankToNull);
const SoapUpdateRequestSchema = _zod.z.object({
    version: _zod.z.number({
        message: 'version must be a number.'
    }).int({
        message: 'version must be a whole number.'
    }).min(0, {
        message: 'version must not be negative.'
    }),
    chiefComplaint,
    subjective: noteText('Subjective'),
    objective: noteText('Objective'),
    plan: noteText('Plan'),
    diagnoses: _zod.z.array(_icd10search.Icd10CodeSchema, {
        message: 'diagnoses must be a list of ICD-10 codes.'
    }).max(DIAGNOSES_MAX_ITEMS, {
        message: `At most ${DIAGNOSES_MAX_ITEMS} diagnoses per encounter.`
    }).refine((codes)=>new Set(codes).size === codes.length, {
        message: 'Each diagnosis code may appear only once.'
    }).optional()
}).strict();
const SoapUpdateResponseSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    version: _zod.z.number().int().min(1),
    updatedAt: _zod.z.string().datetime({
        offset: true
    })
}).strict();
